import {useState, useEffect} from 'react';

const CopyShareLink = ({shareLink}) => {

    const [share, setShare ] = useState('');

    const copyLinkHandler = () => {

        if ( share ) {
            navigator.permissions.query({name: "clipboard-write"}).then(result => {
                if (result.state === "granted" || result.state === "prompt") {
                    navigator.clipboard.writeText(share).then(function() {
                        alert( 'Copied to clipboard' );
                    }, function() {
                        alert( 'failed to copy to clipboard' )
                    });
                }
            });
        }
    }

    useEffect(() => {

        if ( shareLink ) {
            setShare( window.location.origin + '/prospectus/' + shareLink );
        }
    }, [shareLink, setShare])

    return (
        <div className={`${ false === shareLink ? 'disabled' : ''} shareLink`}>
            <span>Copy and share this link:</span>
            <div className="copy cursor" onClick={copyLinkHandler}>
                <input type="text" id="shareLink" className="cursor" value={share} disabled placeholder="https://glos.ac.uk/example-link" />
                <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"></path></svg>
            </div>
        </div>
    )
}

export default CopyShareLink;